module.exports = __webpack_public_path__ + "img/29_64.2006e324.png";